import { Component, OnInit, Input } from '@angular/core';

import { WizardService } from 'app/main/wizard-n35/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';
import {MatTableDataSource} from '@angular/material/table';

import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { lang_resultados35 } from 'app/idiomas/i18n/resultados35/resultados35.lang';

export interface Secciones {
  seccionPregunta: string;
  si: number;
  no: number;
}

const ELEMENT_DATA: Secciones[] = [
  {seccionPregunta: '¿Ha presenciado o sufrido alguna vez, durante o con motivo del trabajo un acontecimiento como los siguientes:', si: null, no:null },
  {seccionPregunta: 'Accidente que tenga como consecuencia la muerte, la pérdida de un miembro o una lesión grave?', si: 27, no: 45},
  {seccionPregunta: 'Asaltos?', si: 2, no: 43},
  {seccionPregunta: 'Actos violentos que derivaron en lesiones graves?', si: 2, no: 43},
  {seccionPregunta: 'Secuestro?', si: 21, no: 42},
  {seccionPregunta: 'Amenazas?', si: 12, no: 43},
  {seccionPregunta: 'Cualquier otro que ponga en riesgo su vida o salud, y/o la de otras personas?', si: 2, no: 43},
];

const ELEMENT_DATA_DOS: Secciones[] = [
  {seccionPregunta: '¿Ha tenido recuerdos recurrentes sobre el acontecimiento que le provocan malestares?', si: 27, no: 45},
  {seccionPregunta: '¿Ha tenido sueños de carácter recurrente sobre el acontecimiento, que le producen malestar?', si: 2, no: 43},
];

const ELEMENT_DATA_TRES: Secciones[] = [
  {seccionPregunta: '¿Se ha esforzado por evitar todo tipo de sentimientos, conversaciones o situaciones que le puedan recordar el acontecimiento?', si: 27, no: 45},
  {seccionPregunta: '¿Se ha esforzado por evitar todo tipo de actividades, lugares o personas que motivan recuerdos del acontecimiento?', si: 2, no: 43},
  {seccionPregunta: '¿Ha tenido difcultad para recordar alguna parte importante del evento?', si: 22, no: 43},
  {seccionPregunta: '¿Ha disminuido su interés en sus actividades cotidianas?', si: 2, no: 43},
  {seccionPregunta: '¿Se ha sentido usted alejado o distante de los demás?', si: 21, no: 43},
  {seccionPregunta: '¿Ha notado que tiene difcultad para expresar sus sentimientos?', si: 2, no: 43},
  {seccionPregunta: '¿Ha tenido la impresión de que su vida se va a acortar, que va a morir antes que otras personas o que tiene un futuro limitado?', si: 2, no: 43},
];

const ELEMENT_DATA_CUATRO: Secciones[] = [
  {seccionPregunta: '¿Ha tenido usted difcultades para dormir?', si: 27, no: 45},
  {seccionPregunta: '¿Ha estado particularmente irritable o le han dado arranques de coraje?', si: 2, no: 43},
  {seccionPregunta: '¿Ha tenido difcultad para concentrarse?', si: 2, no: 43},
  {seccionPregunta: '¿Ha estado nervioso o constantemente en alerta?', si: 2, no: 43},
  {seccionPregunta: '¿Se ha sobresaltado fácilmente por cualquier cosa?', si: 2, no: 43},
];

@Component({
  selector: 'app-at-respuestas-encuesta',
  templateUrl: './at-respuestas-encuesta.component.html',
  styleUrls: ['./at-respuestas-encuesta.component.scss']
})
export class AtRespuestasEncuestaComponent implements OnInit {
  @Input() productoID: any;
  @Input() centroDeTrabajoId:any;

  cargando:boolean=true;
  urlCTIndividual:any;
  tablaRespuestas: MatTableDataSource<backInter.ResultadoEncuesta>;

  displayedColumns: string[] = ['seccionPregunta', 'si', 'no'];
  displayedColumns2: string[] = ['seccionPregunta', 'texto'];
  dataSource = ELEMENT_DATA;
  dataSource2 = ELEMENT_DATA_DOS;
  dataSource3 = ELEMENT_DATA_TRES;
  dataSource4 = ELEMENT_DATA_CUATRO;

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private wizardService: WizardService
  ) {
    lang_resultados35.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.respuestasEncuesta();
    console.log(this.productoID);
    console.log(this.centroDeTrabajoId);
  }

  respuestasEncuesta(){
    let data={
      productoId: this.productoID,
      id_CT:this.centroDeTrabajoId
    }
    if(localStorage.getItem('empresaPadre')){
      this.urlCTIndividual=localStorage.getItem('empresaPadre');
    }
    else{
      this.urlCTIndividual="";
    }
    this.wizardService.respuestasEncuesta(this.urlCTIndividual, data).subscribe( (datos: backInter.respuestasEncuesta) => {
      console.log(datos);
      this.tablaRespuestas=new MatTableDataSource(datos.result);

      this.cargando=false;
    });
  }

}
